import React from 'react';
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import {
    Button,
} from '@themesberg/react-bootstrap'
import Edit from '@mui/icons-material/Edit';


const ActionMenu = (props) => {
    const { handleCreateEdit, handleDelete, data, isHidden } = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl)
    const handleClick = event => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const isDelete = !isHidden({
      module: {
          key: 'TransactionsDriver',
          value: 'D',
      },
  })

  const isEdit = !isHidden({
    module: {
       
           key: "TransactionsDriver",
        value: 'U',
    },
})
    return (
        <>

<>
  <Button
    variant="btn text-btn"
    id="basic-button"
    aria-controls={open ? "basic-menu" : undefined}
    aria-haspopup="true"
    aria-expanded={open ? "true" : undefined}
    onClick={handleClick}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
  >
    <MoreVertRoundedIcon />
  </Button>

  <Menu
    id="basic-menu"
    anchorEl={anchorEl}
    open={open}
    onClose={handleClose}
    MenuListProps={{
      "aria-labelledby": "basic-button",
    }}
  >
    {isEdit && <MenuItem onClick={handleClose} className="p-0">
      <Button
        variant="btn text-btn w-100 d-flex align-items-center gap-2 px-3"
        size="sm"
        onClick={() => handleCreateEdit("Edit", data)}
        // hidden={isHidden({
        //     module: {
               
        //            key: "TransactionsDriver",
        //         value: 'U',
        //     },
        // })}
      >
        <Edit fontSize="small" />
        <span className="text-start flex-grow-1">Edit</span>
      </Button>
    </MenuItem>}

   {isDelete && <MenuItem onClick={handleClose} className="p-0">
      <Button
        variant="btn text-btn w-100 d-flex align-items-center gap-2 px-3"
        size="sm"
        onClick={() => handleDelete(data)}
        // hidden={}
      >
        <DeleteForeverOutlinedIcon fontSize="small" />
        <span className="text-start flex-grow-1">Delete</span>
      </Button>
    </MenuItem>}
  </Menu>
</>

        </>
    )
};

export default ActionMenu;